/** Skill surface — matches API `Skill.type`. */
export const SKILL_ANALYTICS_TYPES = ['organization', 'canvas'] as const;

export type SkillAnalyticsType = (typeof SKILL_ANALYTICS_TYPES)[number];

/** Sharing scope on lifecycle events — `builtIn` is not emitted; map at the call site. */
export const SKILL_ANALYTICS_SCOPES = ['private', 'workspace'] as const;

export type SkillAnalyticsScope = (typeof SKILL_ANALYTICS_SCOPES)[number];
